import React, { useState } from 'react';
import {
    AuthenticationDetails,
    CognitoUser,
    CognitoUserAttribute,
    CognitoUserPool,
} from 'amazon-cognito-identity-js';
import { CLIENT_ID, USER_POOL_ID } from '../__common/env';

export default function useSignIn() {
    const [isLoading, setIsLoading] = useState(false);
    const poolData = {
        UserPoolId: USER_POOL_ID,
        ClientId: CLIENT_ID,
    };
    const handleSignIn = (userName, password) => {
        return new Promise((resolve, reject) => {
            setIsLoading(true);
            const userPool = new CognitoUserPool(poolData);

            const authenticationData = {
                Username: userName,
                Password: password,
            };

            const authenticationDetails = new AuthenticationDetails(
                authenticationData,
            );

            const userData = {
                Username: userName,
                Pool: userPool,
            };

            const cognitoUser = new CognitoUser(userData);

            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: (result) => {
                    cognitoUser.getSession((err, session) => {
                        setIsLoading(false);
                        if (err) {
                            reject('Session error');
                        } else {
                            resolve({
                                mfaRequired: false,
                                session: result,
                                cognitoUser,
                            });
                        }
                    });
                },

                onFailure: (error) => {
                    setIsLoading(false);
                    reject(error);
                },
            });
        });
    };
    const setToken = (token) => {
        localStorage.setItem('authToken', token);
    };

    const resetPasswordOtp = (userEmail) => {
        return new Promise((resolve, reject) => {
            setIsLoading(true);
            const userPool = new CognitoUserPool(poolData);
            const cognitoUser = new CognitoUser({
                Username: userEmail,
                Pool: userPool,
            });

            if (!cognitoUser) {
                setIsLoading(false);
                reject('User not found!');
                return;
            }
            cognitoUser.forgotPassword({
                onSuccess: function (result) {
                    setIsLoading(false);
                    resolve(result);
                },
                onFailure: function (err) {
                    setIsLoading(false);
                    reject(err);
                },
            });
        });
    };

    const confirmPasswordReset = (inUserMail, code, password) => {
        return new Promise((resolve, reject) => {
            setIsLoading(true);
            const userPool = new CognitoUserPool(poolData);
            const cognitoUser = new CognitoUser({
                Username: inUserMail,
                Pool: userPool,
            });
            if (!cognitoUser) {
                setIsLoading(false);
                reject('User not found!');
                return;
            }
            cognitoUser.confirmPassword(code, password, {
                onSuccess: function (result) {
                    setIsLoading(false);
                    resolve(result);
                },
                onFailure: function (err) {
                    setIsLoading(false);
                    reject(err);
                },
            });
        });
    };

    return {
        handleSignIn,
        isLoading,
        setToken,
        resetPasswordOtp,
        confirmPasswordReset,
    };
}
